module.exports = __webpack_public_path__ + "static/media/app-banner-tablet.b0232d74.jpg";